exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".preview-panel[data-v-3360b508] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);
